module.exports = __webpack_public_path__ + "img/1_004.0e5feb05.jpg";